import { createIcon } from '@chakra-ui/icon';
import * as React from 'react';
export var ReceiptIcon = createIcon({
  displayName: 'ReceiptIcon',
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M7 6H12M7 11H12M7 16H12M21 23V3C21 1.89543 20.1046 1 19 1H5C3.89543 1 3 1.89543 3 3V23L6 21.5L9 23L12 21.5L15 23L18 21.5L21 23Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "16.5",
    cy: "6",
    fill: "currentColor",
    r: "1",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "16.5",
    cy: "11",
    fill: "currentColor",
    r: "1",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "16.5",
    cy: "16",
    fill: "currentColor",
    r: "1",
    stroke: "currentColor"
  }))
});
//# sourceMappingURL=Receipt.js.map